import React, {useState} from "react";
import ExpCards from "./ExpCards/ExpCards.jsx";
import Carousel from 'react-bootstrap/Carousel';
import "./experts.scss";

export default function Experts(){


  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    selectedIndex >= 2 ? setIndex(0) : setIndex(selectedIndex);
  };
  const s1="Purti Chawla is an English language expert and Both British Council and IDP cerified IELTS training and has unparalleled expertise in effective exam strategies and to know-how to enhance student's skills in all areas of English.";
  const s2="Akshay Baluni has worked with a widr spectrum of candidates, both international and national and is well versed and thorough with the language proficiency tests. He has worked in the field of Language training since 2009, and has developed curriculum and teaching materials for the same";

  return(
    <div className="experts" id="experts">
    <div className="Headerwithbtn">
    <div className="Heading">Meet our IELTS trainers</div>
    <div className="sliderbuttons">
    <button className="prevBtn" id="prevBtn"  onClick={() =>
            index === 0
              ? setIndex(2)
              : setIndex(index - 1)
          }>&lt;</button>
    <button className="nextBtn" id="nextBtn" onClick={() =>
            index === 2
              ? setIndex(0)
              : setIndex(index + 1)
          }>&gt;</button>
    </div>
    </div>
    <div className="expcards">
    <Carousel className="carousal" activeIndex={index} onSelect={handleSelect}>
    <Carousel.Item className="carousal-item">
    <div className="exp-slide">
    <ExpCards name="Purti" fullname="Purti Chawla" string={s1} />
    <ExpCards name="Akshay" fullname="Akshay Baluni" string={s2}  />
     </div>
     </Carousel.Item>
     <Carousel.Item className="carousal-item">
    <div className="exp-slide">
    <ExpCards name="Purti" fullname="Purti Chawla" string={s1} />
    <ExpCards name="Akshay" fullname="Akshay Baluni" string={s2}  />
      </div>
      </Carousel.Item>
      <Carousel.Item className="carousal-item">
      <div className="exp-slide">
      <ExpCards name="Purti" fullname="Purti Chawla" string={s1} />
      <ExpCards name="Akshay" fullname="Akshay Baluni" string={s2}  />
      </div>
       </Carousel.Item>
     </Carousel>
      </div>
    </div>
  )
}
